const React = require('react');

const ContactSuccess = () => (

  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <rect id="vy95b6c05a" width="24" height="24" x="0" y="0" rx="12" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-168 -614) translate(168 614)">
          <use fill="#00A650" xlinkHref="#vy95b6c05a" />
          <path fill="#FFF" fillRule="nonzero" d="M10.181 14.095L17.046 7.23 18.589 8.773 10.181 17.181 5.41 12.409 6.953 10.866z" />
        </g>
      </g>
    </g>
  </svg>
);

module.exports = ContactSuccess;
